import info from '~/assets/icons/info_2.svg';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import drsLogo from '../../assets/images/drs_logo.svg';
import {
	StyledBottomContainer,
	StyledContainer,
	StyledInfoButton,
	StyledLevelContainer,
	StyledNameProgressContainer,
	StyledProgress,
	StyledProgressWrapper,
	StyledRightContainer,
	StyledTopContainer,
} from './AppTruckJobCompanyProgress.styled';

const AppTruckJobCompanyProgress = () => {
	return (
		<StyledContainer>
			<img src={drsLogo} />
			<div className="dividers">
				<Divider $direction="V" $color={'#000000'} style={{ opacity: 0.5 }} />
				<Divider $direction="V" style={{ opacity: 0.1 }} />
			</div>
			<StyledRightContainer>
				<StyledTopContainer>
					<StyledNameProgressContainer>
						<Text>DRS GROUP</Text>
						<Text>
							Прогресс: <span>1 440</span> / 2 000
						</Text>
					</StyledNameProgressContainer>
					<StyledLevelContainer $active>
						<Text>6</Text>
					</StyledLevelContainer>
				</StyledTopContainer>
				<StyledBottomContainer>
					<StyledProgressWrapper>
						<StyledProgress style={{ width: '50%' }} />
					</StyledProgressWrapper>
					<StyledInfoButton>
						<img src={info} />
					</StyledInfoButton>
				</StyledBottomContainer>
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { AppTruckJobCompanyProgress };
